angular.module('elfium').factory('elfiumModalFactory', ['$uibModal', 'elfiumUrlService', function ($uibModal, elfiumUrlService) {
    return function ($scope, $uibModalInstance, mainObject) {
        var that = this;
        that._init = function () {
            that.unchangedObject = angular.copy(mainObject);
            that._registerClosingEventListener();
        };
        that.mainObjectSaved = function () {
            that.unchangedObject = angular.copy(mainObject);
        };
        that._reallyCloseModal = function () {
            return $uibModal.open({
                templateUrl: elfiumUrlService.getTemplateUrl('elfium', 'elfiumUnsavedChangesModal'),
                size: 'sm'
            });
        };
        that._shouldShowConfirmation = function () {
            return !angular.equals(mainObject, that.unchangedObject);
        };
        that._registerClosingEventListener = function () {
            $scope.$on('modal.closing', function ($event) {
                if (that._shouldShowConfirmation()) {
                    that._showCloseConfirmationAndClose($event);
                }
            });
        };
        that._showCloseConfirmationAndClose = function ($event) {
            $event.preventDefault();
            that._reallyCloseModal().result.then(function () {
                angular.extend(that.unchangedObject, mainObject);
                $uibModalInstance.dismiss();
            });
        };
        that._init();
    };
}]);


// WEBPACK FOOTER //
// ./src/app/components/elfium/elfiumModalFactory.ts